import { render, staticRenderFns } from "./WarningAlert.vue?vue&type=template&id=37d261fe&"
import script from "./WarningAlertVue.ts?vue&type=script&lang=ts&"
export * from "./WarningAlertVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports